import { createSlice } from "@reduxjs/toolkit";
import {
  GetSingleServer, // ✅ Fixed: Corrected from getSingleServer
  blockServer,
  getAllServer,
  saveNewServer,
  updateService, // ✅ Fixed: Corrected from updateServer
} from "../actions/server";

const initialState = {
  servers: [],
  singleServer: null,
  loading: false,
  error: null,
  totalCount:0,
};

const serverSlice = createSlice({
  name: "server",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Single Server
      .addCase(GetSingleServer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleServer.fulfilled, (state, action) => {
        state.loading = false;
        state.singleServer = action.payload;
      })
      .addCase(GetSingleServer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Save New Server
      .addCase(saveNewServer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveNewServer.fulfilled, (state, action) => {
        state.loading = false;
        state.servers.push(action.payload);
      })
      .addCase(saveNewServer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Servers
      .addCase(getAllServer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllServer.fulfilled, (state, action) => {
        const { result, totalDocument } = action.payload;

        state.servers = result;
        state.totalCount = totalDocument;

        state.loading = false;
      })
      .addCase(getAllServer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Server (Renamed correctly to updateService)
      .addCase(updateService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateService.fulfilled, (state, action) => {
        state.loading = false;
        state.servers = state.servers.map((server) =>
          server.id === action.payload.id ? action.payload : server
        );
      })
      .addCase(updateService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Block Server
      .addCase(blockServer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(blockServer.fulfilled, (state, action) => {
        state.loading = false;
        state.servers = state.servers.filter(
          (server) => server.id !== action.payload.id
        );
      })
      .addCase(blockServer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default serverSlice.reducer;
